<template>
    <form-row title="Wire Instructions">
        <div class="flex-1">
            <div class="text-gray-700 leading-snug pt-2">
                <p>
                    {{ $t("To protect against wire fraud and other cyber fraud, C2C strongly recommends that wire transfer arrangements be made directly with the closing/escrow agent and financial institution. You can help protect yourself by observing these protocols:") }}
                </p>

                <ul>
                    <li>
                        <p class="font-semibold mb-2 mt-4 tracking-wide">
                            {{ $t("CALL – DON'T EMAIL") }}
                        </p>

                        <p class="pb-4">
                            {{ $t("Confirm all wiring instructions, including specific banking information, by phone before transferring funds. Contact a trusted representative, using a confirmed phone number, such as the phone number for your closing agent/escrow officer provided on their website or from a business card. Never rely on phone numbers in email communications, and don’t follow up on any emails with wiring instructions, even if the letter looks legitimate.") }}
                        </p>
                    </li>

                    <li>
                        <p class="font-semibold mb-2 mt-4 tracking-wide">
                            {{ $t("CONFIRM EVERYTHING") }}
                        </p>

                        <p class="pb-4">
                            {{ $t("Ask your bank to confirm the account number, the name on the account and the amount to be transferred before sending any wire.") }}
                        </p>
                    </li>

                    <li>
                        <p class="font-semibold mb-2 mt-4 tracking-wide">
                            {{ $t("VERIFY IMMEDIATELY") }}
                        </p>

                        <p class="pb-4">
                            {{ $t("Call your closing agent/escrow officer to confirm the funds were received.") }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        closing: {},
        read_only: { default: false },
    },
}
</script>
